import {useEffect} from 'react'
import {ContentArea} from '@/components/shared/ContentArea'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {usePageTitle} from '@/hooks/use-page-title'
import {useI18n} from '@/i18n'
import {InlineRow} from '@/components/shared/InlineRow'
import {SidebarNav, type SidebarNavItem} from '@/components/layout/SidebarNav'
import {SidebarNavId} from '@/testids/SidebarNavTestIds'
import {routes} from '@/lib/routes'
import {CONCEPT_ICON} from '@/lib/concepts'
import {SectionContainer} from '@/components/shared/SectionContainer'


export function Reporting() {
    const i18n = useI18n()
    usePageTitle(i18n.reporting.pageTitle)
    const location = useLocation()
    const navigate = useNavigate()
    const isRoot = location.pathname === routes.reporting.root()

    // Auto-redirect to categories if at /reporting root
    useEffect(() => {
        if (isRoot) {
            navigate(routes.reporting.categories.path(), {replace: true})
        }
    }, [isRoot, navigate])

    const menuItems: SidebarNavItem[] = [
        {
            id: SidebarNavId.ReportCategories,
            title: i18n.reporting.categories,
            description: i18n.reporting.categoriesDesc,
            href: routes.reporting.categories.path(),
            icon: CONCEPT_ICON.reportCategory,
        },
    ]

    return (
        <SectionContainer>
            <InlineRow align="start">
                <SidebarNav items={menuItems} aria-label={String(i18n.reporting.pageTitle)}/>

                {/* Content */}
                <ContentArea>
                    <Outlet/>
                </ContentArea>
            </InlineRow>
        </SectionContainer>
    )
}
